import { MiniButton } from '@components/ButtonsAlt/MiniButton'
import { Body, Header, Hero } from '@components/EmptyState'
import { Spacer } from '@components/Spacer'
import { getErrorMessage } from '@purposity/utils'
import { altWhite, textGray } from '@themes/Colors'
import Fonts from '@themes/Fonts'
import * as React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import type {
  ClerkTransitionError,
  ComingSoonError,
} from '../../../types/errors'

const DEFAULT_HEADLINE = 'Oops!'
const DEFAULT_MESSAGE = 'Sorry about that.\n\n Looks like we missed a bug.'

type Props = {
  resetError: () => void
  error: Error | ComingSoonError | ClerkTransitionError
  showActualError?: boolean
}

export function ErrorFallbackComponent(props: Props) {
  const showActualError = props.showActualError ?? true

  const headline =
    (showActualError && (props.error as ComingSoonError).formattedName) ||
    DEFAULT_HEADLINE

  const message =
    showActualError && props.error
      ? getErrorMessage(props.error)
      : DEFAULT_MESSAGE
  return (
    <SafeAreaView>
      <View style={styles.container}>
        <Hero style={styles.hero}>
          <Header>{headline}</Header>
          <Body style={styles.body}>{message}</Body>
        </Hero>
        <Text style={styles.cta}>Try again?</Text>
        <Spacer height={12} />
        <MiniButton onPress={() => window.location.reload()}>Reload</MiniButton>
      </View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: altWhite,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
  },
  hero: { maxHeight: 300 },
  body: { paddingHorizontal: 36, color: textGray },
  cta: {
    textAlign: 'center',
    color: textGray,
    fontFamily: Fonts.type.base,
    fontSize: Fonts.size.regular,
    lineHeight: 18,
  },
})
